import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Avatar, IconButton, Menu, MenuItem,
  Card, CardContent, Chip, LinearProgress, Table, TableHead, TableBody, TableRow,
  TableCell, Button, Collapse, Alert, Skeleton, Dialog, DialogTitle, DialogContent,
  DialogActions, TextField, Tooltip } from '@mui/material';
import { Logout, ExpandMore, ExpandLess, NotificationsActive, Flag } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useBranding } from '../../contexts/BrandingContext';
import { facilitatorAPI } from '../../services/api';
import { useSnackbar } from '../../utils/notify';
import dayjs from 'dayjs';

export default function FacilitatorDashboard() {
  var auth = useAuth();
  var branding = useBranding();
  var user = auth.user, logout = auth.logout;
  var navigate = useNavigate();
  var sn = useSnackbar(); var notify = sn.enqueueSnackbar;

  var as = useState(null); var anchorEl = as[0]; var setAnchorEl = as[1];
  var rs = useState(null); var rows = rs[0]; var setRows = rs[1];
  var os = useState({}); var open = os[0]; var setOpen = os[1];
  var bs = useState(false); var busy = bs[0]; var setBusy = bs[1];
  var rm = useState(null); var remindFor = rm[0]; var setRemindFor = rm[1];
  var msg = useState(''); var message = msg[0]; var setMessage = msg[1];
  var fl = useState(null); var flagFor = fl[0]; var setFlagFor = fl[1];
  var nt = useState(''); var note = nt[0]; var setNote = nt[1];

  function load() {
    facilitatorAPI.overview()
      .then(function(r) { setRows(r.data.data || []); })
      .catch(function() { setRows([]); });
  }
  useEffect(load, []);

  function sendReminder() {
    setBusy(true);
    facilitatorAPI.remind(remindFor.reviewer_id, {form_id: remindFor.form_id, message: message})
      .then(function(r) {
        notify((r.data && r.data.message) || 'Reminder sent', {variant:'success'});
        setRemindFor(null); setMessage('');
      })
      .catch(function(e) {
        notify((e.response && e.response.data && e.response.data.error) || 'Could not send', {variant:'error'});
      })
      .then(function() { setBusy(false); });
  }

  function sendFlag() {
    setBusy(true);
    facilitatorAPI.flag({reviewer_id: flagFor.reviewer_id, form_id: flagFor.form_id, note: note})
      .then(function() {
        notify('Raised with the admins', {variant:'success'});
        setFlagFor(null); setNote('');
      })
      .catch(function(e) {
        notify((e.response && e.response.data && e.response.data.error) || 'Could not send', {variant:'error'});
      })
      .then(function() { setBusy(false); });
  }

  var E = React.createElement;

  var chrome = function(body) {
    return E(Box, {sx:{minHeight:'100vh', bgcolor:'background.default'}},
      E(AppBar, {position:'static', sx:{bgcolor:'primary.main'}},
        E(Toolbar, null,
          E(Typography, {variant:'h6', sx:{flexGrow:1}}, branding.portal_name + ' \u2014 Follow-up'),
          E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
            E(Typography, {variant:'body2'}, user && user.name),
            E(IconButton, {color:'inherit', onClick:function(e){ setAnchorEl(e.currentTarget); }},
              E(Avatar, {sx:{width:32, height:32, bgcolor:'secondary.main', fontSize:14}},
                user && user.name ? user.name.charAt(0).toUpperCase() : '?')),
            E(Menu, {anchorEl:anchorEl, open:Boolean(anchorEl),
              onClose:function(){ setAnchorEl(null); }},
              E(MenuItem, {onClick:function(){ navigate('/reviewer'); setAnchorEl(null); }},
                'My own reviews'),
              (user && user.role) === 'admin'
                ? E(MenuItem, {onClick:function(){ navigate('/admin'); setAnchorEl(null); }}, 'Admin panel')
                : null,
              E(MenuItem, {onClick:function(){ logout(); navigate('/login'); }},
                E(Logout, {sx:{mr:1, fontSize:18}}), 'Sign out'))))),
      E(Box, {sx:{maxWidth:1200, mx:'auto', p:3}}, body));
  };

  if (rows === null) {
    return chrome(E(Skeleton, {variant:'rectangular', height:280, sx:{borderRadius:2}}));
  }

  if (rows.length === 0) {
    return chrome(E(Card, null, E(CardContent, {sx:{textAlign:'center', py:8}},
      E(Typography, {variant:'h6', sx:{mb:1}}, 'No reviewers assigned to you yet'),
      E(Typography, {color:'text.secondary'},
        'An administrator decides which reviewers you follow up with.'))));
  }

  var grandTotal = 0, grandDone = 0;
  rows.forEach(function(g) { grandTotal += g.total; grandDone += g.counts.completed; });

  return chrome(E(Box, null,
    E(Typography, {variant:'h4', sx:{mb:2}}, 'Review progress'),

    E(Card, {sx:{mb:3}},
      E(CardContent, null,
        E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'baseline', mb:1}},
          E(Typography, {variant:'subtitle1', fontWeight:600},
            grandDone + ' of ' + grandTotal + ' reviews complete'),
          E(Typography, {variant:'body2', color:'text.secondary'},
            rows.length + ' reviewer' + (rows.length === 1 ? '' : 's'))),
        E(LinearProgress, {variant:'determinate',
          value: grandTotal ? (grandDone / grandTotal) * 100 : 0,
          sx:{height:8, borderRadius:4}}))),

    rows.map(function(g) {
      var key = g.reviewer_id + '|' + g.form_id;
      var isOpen = !!open[key];
      var pct = g.total ? (g.counts.completed / g.total) * 100 : 0;
      return E(Card, {key:key, sx:{mb:2}},
        E(CardContent, null,
          E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'flex-start',
            flexWrap:'wrap', gap:1}},
            E(Box, {sx:{minWidth:0}},
              E(Typography, {variant:'h6'}, g.reviewer_name),
              E(Typography, {variant:'body2', color:'text.secondary'},
                g.form_title + ' \u2022 ' + g.reviewer_email),
              !g.is_active
                ? E(Chip, {size:'small', color:'warning', label:'Account disabled', sx:{mt:0.5}})
                : null),
            E(Box, {sx:{display:'flex', gap:0.5, alignItems:'center', flexWrap:'wrap'}},
              E(Chip, {size:'small', label:g.counts.completed + ' done', color:'success'}),
              E(Chip, {size:'small', label:g.counts.in_progress + ' in progress',
                color: g.counts.in_progress ? 'warning' : 'default', variant:'outlined'}),
              E(Chip, {size:'small', label:g.counts.pending + ' not started', variant:'outlined'}))),

          E(LinearProgress, {variant:'determinate', value:pct,
            sx:{height:6, borderRadius:3, my:1.5}}),

          E(Box, {sx:{display:'flex', gap:1, flexWrap:'wrap', alignItems:'center'}},
            E(Button, {size:'small', onClick:function(){
              var o = Object.assign({}, open); o[key] = !isOpen; setOpen(o);
            }, endIcon: isOpen ? E(ExpandLess) : E(ExpandMore)},
              isOpen ? 'Hide applications' : 'Show ' + g.total + ' applications'),
            E(Tooltip, {title: g.counts.completed === g.total ? 'Nothing outstanding' : ''},
              E('span', null,
                E(Button, {size:'small', startIcon:E(NotificationsActive),
                  disabled: g.counts.completed === g.total,
                  onClick:function(){ setRemindFor(g); setMessage(''); }}, 'Send reminder'))),
            E(Button, {size:'small', startIcon:E(Flag), color:'warning',
              onClick:function(){ setFlagFor(g); setNote(''); }}, 'Flag to admin'),
            E(Typography, {variant:'caption', color:'text.secondary'},
              g.last_login ? 'Last signed in ' + dayjs(g.last_login).format('MMM D, HH:mm')
                           : 'Never signed in')),

          E(Collapse, {in:isOpen},
            E(Box, {sx:{mt:2}},
              g.anonymous
                ? E(Typography, {variant:'caption', color:'text.secondary',
                    sx:{display:'block', mb:1, fontStyle:'italic'}},
                    'This form is reviewed anonymously, so applications show as reference numbers.')
                : null,
              E(Table, {size:'small'},
                E(TableHead, null,
                  E(TableRow, null,
                    E(TableCell, null, 'Application'),
                    E(TableCell, null, 'Status'),
                    E(TableCell, null, 'Assigned'),
                    E(TableCell, null, 'Last activity'))),
                E(TableBody, null,
                  g.applications.map(function(a) {
                    return E(TableRow, {key:a.assignment_id},
                      E(TableCell, null, a.label),
                      E(TableCell, null,
                        E(Chip, {size:'small', label:a.status.replace('_', ' '),
                          color: a.status === 'completed' ? 'success'
                               : a.status === 'in_progress' ? 'warning' : 'default',
                          variant: a.status === 'pending' ? 'outlined' : 'filled'})),
                      E(TableCell, null, a.assigned_at ? dayjs(a.assigned_at).format('MMM D') : '\u2014'),
                      E(TableCell, null,
                        a.submitted_at ? dayjs(a.submitted_at).format('MMM D, HH:mm')
                          : a.last_activity ? dayjs(a.last_activity).format('MMM D, HH:mm')
                          : '\u2014'));
                  })))))));
    }),

    // Reminder
    remindFor ? E(Dialog, {open:true, onClose:function(){ setRemindFor(null); },
      maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, 'Remind ' + remindFor.reviewer_name),
      E(DialogContent, null,
        E(Typography, {variant:'body2', color:'text.secondary', sx:{mb:2}},
          'They have ' + (remindFor.total - remindFor.counts.completed) +
          ' application(s) still to review on ' + remindFor.form_title + '.'),
        E(TextField, {autoFocus:true, fullWidth:true, multiline:true, rows:3,
          label:'Add a note (optional)', value:message,
          onChange:function(e){ setMessage(e.target.value); }})),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setRemindFor(null); }}, 'Cancel'),
        E(Button, {variant:'contained', disabled:busy, onClick:sendReminder}, 'Send'))) : null,

    // Flag
    flagFor ? E(Dialog, {open:true, onClose:function(){ setFlagFor(null); },
      maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, 'Flag to the admins'),
      E(DialogContent, null,
        E(Alert, {severity:'info', sx:{mb:2}},
          'Facilitators cannot reassign work. This sends your note to the admins and records it in the audit log.'),
        E(TextField, {autoFocus:true, fullWidth:true, multiline:true, rows:4,
          label:'What needs attention?', value:note,
          placeholder:'e.g. this reviewer has not started and is not responding',
          onChange:function(e){ setNote(e.target.value); }})),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setFlagFor(null); }}, 'Cancel'),
        E(Button, {variant:'contained', color:'warning', disabled:busy || !note.trim(),
          onClick:sendFlag}, 'Send'))) : null));
}
